import React, { useState } from 'react'
import EditShippingFeed from '../EditShippingFeed/EditShippingFeed'

// includes
import CategoriesListing from '../../commonIncludes/CategoriesListing'

export default function SendersInfo(props) {
    // props
    const {
        defaultValue,

        getSelectedCategory,

        categoriesDetails
    } = props

    return (
        <React.Fragment>
            {/* page border box 2 */}
            <div className="page-border-box2 mb-3 mb-md-4 generate-shipping-feed">
                <div className="pbb2-inner d-flex">
                    <div className="text-sec media-body pe-3">
                        {/* HEADER */}
                        <div className="app-header-wrapper heading-sm mb-2">
                            <p className="app-heading text-capitalize mb-2">Generate Google Shopping feed</p>
                            <p className="app-desc st-fs-14">
                                Generate your product XML feed and upload it to Google Merchant Center to manage your ads or marketing campaigns manually. The feed will regenerate automatically every 5 hours.
                            </p>
                        </div>

                        {/* CONTENT */}
                        <div className="content">
                            {
                                console.log("categoriesDetails ", categoriesDetails)
                            }
                            {
                                (categoriesDetails !== null) ? ( // if the feed link exists
                                    <div className="feed-link-value">
                                        <p>
                                            <span className="st-fw-600">Feed Link </span>
                                            <a
                                                href={categoriesDetails?.feed_link}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="st-text-primary">{categoriesDetails?.feed_link}</a>
                                        </p>
                                    </div>
                                ) : (
                                    <CategoriesListing
                                        defaultValue={defaultValue}

                                        getSelectedCategory={getSelectedCategory}
                                    />
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>

            {
                /* edit shipping feed */
                (categoriesDetails !== null) ? ( // if the feed link exists
                    <EditShippingFeed
                        categoriesDetails={categoriesDetails}
                    />
                ) : null
            }
        </React.Fragment>
    )
}
